import React from "react";
import { motion } from "framer-motion";
import { CalendarCheck, Truck, MapPin, Wallet } from "lucide-react";
import { classes } from "./tokens";

const steps = [
  { n: "01", icon: CalendarCheck, title: "Book service online",   desc: "Pick your car, share address. OTP-verify in 60 seconds. No advance.", tone: "from-blue-100 to-blue-200" },
  { n: "02", icon: Truck,         title: "Free doorstep pickup",  desc: "Certified driver picks up your car within 60 minutes. GPS-tracked.", tone: "from-blue-100 to-blue-200" },
  { n: "03", icon: MapPin,        title: "Real-time tracking",    desc: "Live photos and progress on WhatsApp. Service done at certified workshop.", tone: "from-green-100 to-green-200" },
  { n: "04", icon: Wallet,        title: "Pay only after",        desc: "Car back at your doorstep. Pay via UPI / card / cash — only when satisfied.", tone: "from-amber-100 to-amber-200" },
];

const HowItWorks = () => (
  <section
    className="py-16 lg:py-24 bg-white"
    data-testid="how-it-works-section"
  >
    <div className={classes.container}>
      <div className="text-center mb-12 max-w-2xl mx-auto">
        <span className={classes.overline}>How It Works</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-slate-900 leading-tight mt-2">
          Four steps. Zero hassle.<br />
          <span className="text-slate-500">From booking to delivery.</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.4, delay: i * 0.08 }}
            className="text-center"
          >
            <div className="relative inline-block mb-5">
              <div className={`w-24 h-24 rounded-3xl bg-gradient-to-br ${s.tone} inline-flex items-center justify-center shadow-sm`}>
                <s.icon className="h-12 w-12 text-blue-600" strokeWidth={2} />
              </div>
              <span className="absolute -top-2 -left-2 w-9 h-9 rounded-full bg-slate-900 text-white font-mono font-extrabold text-xs inline-flex items-center justify-center shadow-md ring-4 ring-white">
                {s.n}
              </span>
            </div>
            <h3 className="text-lg lg:text-xl font-extrabold text-slate-900 mb-2 leading-snug">
              {s.title}
            </h3>
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs mx-auto">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
